module.exports = __webpack_public_path__ + "img/icon-calendar.4408a4bf.svg";